import { render } from "./Expired-product.vue?vue&type=template&id=923937ca&scoped=true"
import script from "./Expired-product.vue?vue&type=script&lang=js"
export * from "./Expired-product.vue?vue&type=script&lang=js"

import "./Expired-product.vue?vue&type=style&index=0&id=923937ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923937ca"]])

export default __exports__